import type { FC } from 'react';
import React from 'react';

import styles from './Promo.module.css';
import { config } from '../../../state/config';
import { useState } from '../../../state/store';
import { Page } from '../../../state/types';

const Promo: FC = () => {
  const { page } = useState('page');

  if (page !== Page.Home) {
    return null;
  }

  return (
    <div className="p-0 py-4 p-md-8">
      <div className={`${styles.Promo} container flex flex-col text-center`} data-testid="PromoPage">
        <section>
          <img
            src={`${config.publicUrl}/img/promo/banner_landscape.jpg`}
            alt="Galaxy Z Fold 5 | Z Flip 5"
            className="d-sm-none d-md-inline-block"
          />
          <img
            src={`${config.publicUrl}/img/promo/banner_portrait.jpg`}
            alt="Galaxy Z Fold 5 | Z Flip 5"
            className="d-none d-md-none d-sm-block"
          />
          <p className="lead mt-4">The Samsung Galaxy Flip 5 / Fold 5 trade-in promotion has now closed.</p>
          <p className="lead">Please visit the site again soon to avail of Samsung's latest trade in promotion.</p>
          <br />
          <br />
          <p className="lead">Thank You.</p>
          <br />
          <br />
        </section>
      </div>
    </div>
  );
};

export default Promo;